import React from 'react';

interface InfoCircleIconProps {
  className?: string;
  color?: string;
  size?: number;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function InfoCircleIcon({
  className = "",
  color = 'currentColor',
  size,
  width,
  height
}: InfoCircleIconProps) {
  const w = size || width || 24;
  const h = size || height || 24;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
